import FreshbotsWidget from './FreshbotsWidget';

export default FreshbotsWidget;
